import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class HashRouteRedirectGuard implements CanActivate {
  constructor(private router: Router) {}

  private redirectToRoute(route: string): void {
    window.location.href = route;
  }

  canActivate(): boolean {
    // keep compatibility with hash routing and redirect to corresponding route without hashing
    if (window.location.hash.startsWith('#/')) {
      this.redirectToRoute(window.location.hash.slice(1));
      return null;
    }
    this.router.navigate(['booking-no-longer-valid']);
  }
}
